import { V9ReportParameter } from './v9-report-parameter.model';

export class ReportV9 {
    Id: number;
    ParentId: number;
    Description: string;
    ReportName: string;
    ReportTitle: string;
    ReportType: number;
    Active: boolean;
    WorkflowReport: boolean;
    MinimumStudentsForWorkflow: number;
    ReportParameterClassName: string;
    StudentIds: string;
    ReportsList: ReportV9[];
    ReportParameters: V9ReportParameter[];
    ReportValue: number;
    SchoolId: number;
    YearId: number;
    SiteSectionId: number;
}
